import { useMemo } from 'react';

import { AvailableLineDataRefNode } from '@futrli-sdk/predict';

import { convertFormulaOptionsToMentionData } from './utils';

export const useProcessedFormulaOptions = (formulaOptions?: AvailableLineDataRefNode[]) =>
  useMemo(() => convertFormulaOptionsToMentionData(formulaOptions || []), [formulaOptions]);
